<template>
    <kiosk-org-unit-details :teamId="props.teamId" :orgUnitId="props.orgUnitId">
        <div class="flex flex-col w-full justify-center">
            <div class="max-w-(--breakpoint-sm) flex flex-col">
                <page-callout section="kiosk-org-unit-configuration" class="mb-4" />

                <page-header>Configuration</page-header>

                <update-org-unit-hubspot
                    :teamId="props.teamId"
                    :orgUnitId="props.orgUnitId"
                    :isEditable="props.teamStatus !== 'closed'"
                    class="mb-4"
                />
            </div>
        </div>
    </kiosk-org-unit-details>
</template>

<script setup>
import KioskOrgUnitDetails from '~/components/kiosk/kiosk-org-units/details/KioskOrgUnitDetails.vue';
import PageHeader from '~/components/general/PageHeader.vue';
import PageCallout from '~/components/general/PageCallout.vue';
import UpdateOrgUnitHubspot from '~/components/kiosk/kiosk-org-units/configuration/UpdateOrgUnitHubspot.vue';

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    orgUnitId: {
        type: Number,
        required: true,
    },
    teamStatus: {
        type: String,
        required: true,
    },
});
</script>
